import GenericDictionaryPage from "./GenericDictionaryPage";
import { getImprovementPlanDeleteReason } from "../api/improvementPlanDeleteReason";

export default function ImprovementPlanDeleteReasons() {
    return (
        <GenericDictionaryPage
            tableKey="improvementPlanDeleteReasons"
            fetchData={getImprovementPlanDeleteReason}
            titleKey="genericDic:improvementPlanDeleteReasons"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:improvementPlanDeleteReasons").toLowerCase()
                })
            }
        />
    );
}
